import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export class PokerChipIcon extends React.Component<ISvgIconProps> {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 19 18" fill={'none'}>
                <g clipPath="url(#clip0_11018_281868)">
                    <path d="M9.29233 7.61963C11.265 7.61963 12.8642 6.05755 12.8642 4.13062C12.8642 2.20369 11.265 0.641602 9.29233 0.641602C7.31964 0.641602 5.72046 2.20369 5.72046 4.13062C5.72046 6.05755 7.31964 7.61963 9.29233 7.61963Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12.8641 13.6665C14.8368 13.6665 16.436 12.1044 16.436 10.1775C16.436 8.25056 14.8368 6.68848 12.8641 6.68848C10.8914 6.68848 9.29224 8.25056 9.29224 10.1775C9.29224 12.1044 10.8914 13.6665 12.8641 13.6665Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M5.71591 13.6665C7.6886 13.6665 9.28779 12.1044 9.28779 10.1775C9.28779 8.25056 7.6886 6.68848 5.71591 6.68848C3.74322 6.68848 2.14404 8.25056 2.14404 10.1775C2.14404 12.1044 3.74322 13.6665 5.71591 13.6665Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M14.4644 17.354C11.6043 17.354 9.28614 15.0897 9.28614 12.2959C9.28614 15.0897 6.96802 17.354 4.10791 17.354H14.4578H14.4644Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_11018_281868">
                        <rect width="15.6" height="18" fill="currentColor" transform="translate(1.48999)"/>
                    </clipPath>
                </defs>
            </SvgIcon>
        );
    }
}
